
import { defineComponent, ref, onMounted, watch } from "vue";
import { hideModal } from "@/core/helpers/dom";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";
import Quill from "quill";
import { useRoute } from "vue-router";

export default defineComponent({
  name: "delete-funding-round-modal",
  components: {},
  props: {
    businessId: {
      required: true,
      type: Number,
    },
    bypass:{
      required: false,
      type: Boolean
    }
  },
  setup(props, { emit }) {
    const route = useRoute();
    let termsAndConditions = { value: "" };
    const inner = ref<string>("");
    const store = useStore();
    const formRef = ref<null | HTMLFormElement>(null);
    const newTargetModalRef = ref<null | HTMLElement>(null);
    const loading = ref<boolean>(false);
    const id = ref<string | number>(props.businessId)
    watch(() => props.businessId, value => id.value = value)
    const connect = async () => {
      loading.value = true;
      try {
        const response = await store.dispatch(
          props.bypass ? Actions.INVESTMENT_OPPORTUNITY_CONNECT_PUBLIC  : Actions.INVESTMENT_OPPORTUNITY_CONNECT,
          props.bypass ? {
            data: {
              founderBusinessId: props.businessId,
            },
            userToken: route.query.userToken
          } : {
            founderBusinessId: props.businessId,
          }
        );
        if (response !== true) throw new Error();
        loading.value = false;
        emit("connected")
        store.commit("setAlert", {
          message: "Success",
          subMessage: "Investment Opportunity Connected",
          variant: "primary",
          duration: 4000,
          show: true,
        });
        hideModal(newTargetModalRef.value);
      } catch (err) {
        loading.value = false;
        store.commit("setAlert", {
          message: "Error",
          subMessage: "Investment Opportunity Not Connected",
          variant: "danger",
          duration: 4000,
          show: true,
        });
      }
    };
    onMounted(async () => {
      try {
        const response = await store.dispatch(
          Actions.GET_CONFIGURATION_BY_KEY,
          "disclaimer"
        );
        if (!response.success) throw new Error();
        termsAndConditions = response.data;
        let article = document.createElement("article");
        let quill = new Quill(article, { readOny: true });
        quill.setContents(JSON.parse(termsAndConditions.value));
        inner.value = quill.root.innerHTML;
      } catch (err) {
        console.log(err);
      }
    });
    return {
      connect,
      loading,
      formRef,
      newTargetModalRef,
      inner,
      id
    };
  },
});
